module.exports = __webpack_public_path__ + "img/canada-colorectal-cancer-male.7f83052c.png";